"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/tooltip/style");
var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
require("./ClinicianAccountInfo.less");
var _utils = require("../../../utils");
var _ = require("../");
var _EditableEmail = require("../../EditableEmail");
var _endpoints = require("../../../utils/endpoints");
var _ClinicianPaidToBy = _interopRequireDefault(require("../ClinicianPaidToBy"));
var _classMap;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Text = _typography.default.Text,
  Title = _typography.default.Title;
var classMap = (_classMap = {}, _defineProperty(_classMap, _utils.AccountStatus.Active, 'ant-tag-light-green'), _defineProperty(_classMap, _utils.AccountStatus.New, 'ant-tag-dark-green'), _defineProperty(_classMap, _utils.AccountStatus.Deactivated, 'ant-tag-grey'), _classMap);
var roles = (0, _utils.getClinicianRoles)();
var ClinicianInfo = function ClinicianInfo(_ref) {
  var _roles$find;
  var _ref$isSuperAdmin = _ref.isSuperAdmin,
    isSuperAdmin = _ref$isSuperAdmin === void 0 ? false : _ref$isSuperAdmin,
    _ref$clinician = _ref.clinician,
    status = _ref$clinician.status,
    role = _ref$clinician.role,
    email = _ref$clinician.email,
    createdAt = _ref$clinician.createdAt,
    licenses = _ref$clinician.licenses,
    clinicianId = _ref$clinician.id,
    type = _ref.type,
    onUpdateStatus = _ref.onUpdateStatus,
    handleSimulateUser = _ref.handleSimulateUser;
  var handleUpdateStatus = function handleUpdateStatus(e) {
    e.preventDefault();
    var newStatus = status === _utils.AccountStatus.Deactivated ? _utils.AccountStatus.Active : _utils.AccountStatus.Deactivated;
    onUpdateStatus(newStatus);
  };
  var handleClinicianEmailSubmit = function handleClinicianEmailSubmit(values) {
    updateClinicianEmail(values.email);
  };
  var _useRequest = (0, _utils.useRequest)(function (newEmail) {
      return {
        url: (0, _endpoints.getClinicianEmailUrl)(clinicianId),
        method: 'patch',
        data: {
          email: newEmail
        }
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _utils.toast.success({
          title: 'Success!',
          description: 'Clinician email has been successfully changed.'
        });
      }
    }),
    updateClinicianEmail = _useRequest.run;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ClinicianAccountInfo"
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-shadow ant-card-narrow",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Account info"),
    bordered: false,
    extra: status && /*#__PURE__*/_react.default.createElement("span", {
      className: "ant-tag ".concat(classMap[status])
    }, (0, _lodash.findKey)(_utils.AccountStatus, function (value) {
      return value === status;
    }))
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "Role:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, (_roles$find = roles.find(function (item) {
    return item.value === role;
  })) === null || _roles$find === void 0 ? void 0 : _roles$find.text)), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "Email:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, isSuperAdmin ? /*#__PURE__*/_react.default.createElement(_EditableEmail.EditableEmail, {
    email: email,
    onSubmit: handleClinicianEmailSubmit
  }) : email)), type === 'admin' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "License state:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, (0, _utils.getStatesString)(licenses))), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "Join date:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, (0, _utils.formatDate)(createdAt))), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "Accepting new patients"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, clinicianId && /*#__PURE__*/_react.default.createElement(_.AvailabilityForNewPatients, {
    clinicianId: clinicianId
  }))), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "Paid by Monument"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, clinicianId && /*#__PURE__*/_react.default.createElement(_ClinicianPaidToBy.default, {
    clinicianId: clinicianId
  }))), role === roles[1].value && /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 6,
      offset: 0
    }
  }, "Coach Only"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 1
    }
  }, clinicianId && /*#__PURE__*/_react.default.createElement(_.CoachOnlyToggle, {
    clinicianId: clinicianId
  }))), /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: handleUpdateStatus
  }, status === _utils.AccountStatus.Deactivated ? /*#__PURE__*/_react.default.createElement(Text, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "check-circle-o"
  }), " Activate") : /*#__PURE__*/_react.default.createElement(Text, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "close-circle-o"
  }), " Deactivate")), isSuperAdmin && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    placement: "top",
    title: "Navigate to Clinician application"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: handleSimulateUser
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "info-circle-o"
  }), "Simulate Clinician")))));
};
ClinicianInfo.propTypes = {
  isSuperAdmin: _propTypes.default.bool,
  clinician: _propTypes.default.shape({
    status: _propTypes.default.number,
    role: _propTypes.default.number,
    email: _propTypes.default.string,
    createdAt: _propTypes.default.string
  }),
  onUpdateStatus: _propTypes.default.func,
  handleSimulateUser: _propTypes.default.func
};
var _default = ClinicianInfo;
exports.default = _default;